


























import { defineComponent, useRouter } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

// Composables
import { useSearchStore } from '@/store/search'
import useSearchUrl from '@/composables/search/useSearchUrl'
import useSearchAnalytics from '@/composables/analytics/useSearchAnalytics'

// Components
import Skeleton from '@/components/global/skeletons/Skeleton.vue'

// Common
import { SEARCH_TYPES } from '@/common/static/search'

export default defineComponent({
  components: {
    Skeleton,
  },
  setup() {
    const { trackSearchItemtypeTab } = useSearchAnalytics()
    const searchStore = useSearchStore()
    const { tabs, ui } = storeToRefs(searchStore)
    const { getSearchUrl } = useSearchUrl()
    const router = useRouter()

    // adjust on click
    const switchTab = (value: string) => {
      // first set the new tab
      searchStore.setSelectedTab(value)

      // set pagination to 1
      searchStore.setCurrentPage(1)

      // if the tab count is zero, abort mission
      if (value === undefined || tabs.value.tabCount[value as keyof typeof tabs.value.tabCount] === 0) {
        return
      }

      // send GTM event
      trackSearchItemtypeTab()

      // search again
      router.push(getSearchUrl({ redirect: false, nr: 1 }))
    }

    return {
      switchTab,
      tabs,
      ui,
      SEARCH_TYPES,
    }
  },
})
